import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { WaiterLoginModel } from "src/app/share-modul/models/login/waiter-login.model";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "src/environments/environment";
// import { CreateOrEditCapacityModel } from "../../models/tables/create-or-edit-capacity.model";
// import { VenueModel } from "../../models/venues/venue.model";
// import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
// import { DivisionModel } from "../../models/divisions/division.model";

const MNG_VENUE_API = environment.apiURL + '/api/mng/Venue/';

@Injectable({
  providedIn: 'root'
})

export class VenueService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listvenues() {
    var url = MNG_VENUE_API + "listvenues";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }


  getvenuedetails(id: string) {
    var url = MNG_VENUE_API + 'getvenuedetails?venueId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  unpairdevice(model: WaiterLoginModel){
    let url = MNG_VENUE_API + 'unpairdevice';
    return this._httpService.httpPost(url,model)
      .pipe(map(resposne => {
        return resposne;
      }));

  }


//   viewVenueCapacity(venueId: string){
//     var url = CAPACITY_API + "viewcapacity?VenueId=" + venueId;
//     return this._httpService.httpGet(url)
//       .pipe(map(resposne => {
//         return resposne;
//       }));
//   }

  listallmngvenuesforcombo() {
    var url = MNG_VENUE_API + "listvenuesforcombo";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

//   listVenueDivisions(venueId: string) {
//     let url = GMN_VENUE_API + 'listsubvenues?venueId=' + venueId;
//     return this._httpService.httpGet(url)
//       .pipe(map(response => {
//         return response;
//       }));
//   }


  getMenuItemsForDivision(divisionId: string,selectedDate: any) {
    let url = MNG_VENUE_API + 'getmenuitemsforsubvenue?subVenueId=' + divisionId + '&selectedDate='+selectedDate;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  //#endregion
}
